import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD} from "../../../constants/unlock_choice_price_negotiation";
import {UnlockChoiceModalDataSharingNotice} from "./UnlockChoiceModalDataSharingNotice";

interface IProps {
    vendorName: string | null;
    privacyPolicyUrl: string | null;
    isSending: boolean;
    isConfirmDisabled: boolean;
    isArmed: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalPriceNegotiationFooter = (props: IProps) => {
    const {vendorName, privacyPolicyUrl, isSending, isConfirmDisabled, isArmed, onConfirm} = props;

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <UnlockChoiceModalDataSharingNotice vendorName={vendorName} privacyPolicyUrl={privacyPolicyUrl} className={clauseStyle} />

            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    aria-disabled={isArmed ? undefined : true}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON}
                >
                    {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD.ctaText}
                </Button>
            </div>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    md: {
        px: 3,
        pb: 1.5
    }
});

const ctaStyle = css({
    py: 1.5
});

const clauseStyle = css({
    py: 1.5
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD} from "../../../constants/unlock_choice_price_negotiation";
import {UnlockChoiceModalDataSharingNotice} from "./UnlockChoiceModalDataSharingNotice";

interface IProps {
    vendorName: string | null;
    privacyPolicyUrl: string | null;
    isSending: boolean;
    isConfirmDisabled: boolean;
    isArmed: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalPriceNegotiationFooter = (props: IProps) => {
    const {vendorName, privacyPolicyUrl, isSending, isConfirmDisabled, isArmed, onConfirm} = props;

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <UnlockChoiceModalDataSharingNotice vendorName={vendorName} privacyPolicyUrl={privacyPolicyUrl} className={clauseStyle} />

            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    aria-disabled={isArmed ? undefined : true}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON}
                >
                    {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD.ctaText}
                </Button>
            </div>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    md: {
        px: 3,
        pb: 1.5
    }
});

const ctaStyle = css({
    py: 1.5
});

const clauseStyle = css({
    py: 1.5
});
